/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { InwardChargeType } from 'app/shared/model/enumerations/inward-charge-type.model';
import { HikeType } from 'app/shared/model/enumerations/hike-type.model';

export interface IOPCharge {
  id?: string;
  name?: string | null;
  description?: string | null;
  charge?: number | null;
  chargeType?: keyof typeof ChargeType | null;
  relatedTo?: keyof typeof InwardChargeType | null;
  tax?: string | null;
  emergencyHike?: number | null;
  hishRiskHike?: number | null;
  emergencyHikeType?: keyof typeof HikeType | null;
  hishRiskHikeType?: keyof typeof HikeType | null;
  active?: boolean | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  lastUpdated?: number | null;
  cursor?: number | null;
  hospital?: IHospital;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IOPCharge> = {
  active: false,
};
